var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.FormFooter,{staticClass:"form_footer",attrs:{"fixed":"","offset":"left","offsetInPixels":248}},[_c('div',{staticClass:"form_footer__controls_container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }